import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { Checkbox } from 'antd';
import { ISubCategoryContext, SubCategoryContext } from '../../../subCategoryState/subCategoryContext';

const SubCategoryIsHiddenCheckBox: React.FC = () => {
	const { toggleSubCategoryIsHidden, IDSelectedCustomer, IDSelectedRestaurant, subCategoryIsHidden } =
		useContext<ISubCategoryContext>(SubCategoryContext);

	return (
		<Checkbox
			onChange={toggleSubCategoryIsHidden}
			checked={subCategoryIsHidden}
			disabled={!IDSelectedCustomer || !IDSelectedRestaurant}
			data-test="SubCategoryIsHiddenCheckBox">
			<Text translationNameSpace="listing" translationKey="subcategoryHiddenLabel" asFragment={true} />
		</Checkbox>
	);
};

export default SubCategoryIsHiddenCheckBox;
